import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
  getAppointmentTimeInUrlFormat,
  getBarberRoute,
  getServiceIds,
  getShopRoute,
} from '../selectors';

const mapStateToProps = state => ({
  shopRoute: getShopRoute(state),
  barberRoute: getBarberRoute(state),
  serviceId: getServiceIds(state),
  reservationTime: getAppointmentTimeInUrlFormat(state),
});

export default compose(
  withRouter,
  connect(mapStateToProps),
  withProps(props => ({
    serviceId: props.serviceId,
    barberRoute: props.barberRoute,
    shopRoute: props.shopRoute,
    reservationTime: props.reservationTime,
    ...props.params,
  }))
);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/withRouteParameters.js